/**
 * extensions/dicom-rt/src/modules/dicom-measurement/src/assessments/isBoneLesion.js
 *
 * RECIP 1.0 bone vs soft-tissue dispatch.
 *
 * Strict exact-match policy (per PLAN.md §2):
 *   Only a bodyPart of exactly 'bone' (case-insensitive) is bone.
 *   All other body parts — including missing / empty — fall through to
 *   soft-tissue. This is the conservative fallback: if the reader hasn't set
 *   a body part, we require the liver threshold before classifying, which
 *   prevents silent misclassification as bone when the lesion may be in a
 *   soft-tissue organ.
 *
 * Exported standalone so it can be imported by both
 * applyPsmaClassificationFromBridge and getRecipResponse without creating a
 * circular dependency.
 */

/**
 * @param {object} roi  ROI object with optional bodyPart string
 * @returns {boolean}   true iff the ROI's body part is exactly 'bone'
 */
export function isBoneLesion(roi) {
  const bp = (roi?.bodyPart || '').trim().toLowerCase();
  return bp === 'bone';
}
